/**
 * Computes whether new-document CTAs should be visible after an overlay lifecycle transition.
 *
 * Called by Quick Edit close, Draft close, and Commander close paths
 * to enforce the invariant: CTAs show only when the document is empty.
 */
export function getNewDocumentCTAVisibilityOnOverlayClose(
  getText: () => string | undefined | null
): boolean {
  const text = getText();
  return !text;
}

/**
 * Computes whether new-document CTAs should be hidden when an overlay opens.
 * Always returns false (CTAs are hidden while any overlay is active).
 */
export function getNewDocumentCTAVisibilityOnOverlayOpen(): boolean {
  return false;
}
